import * as confirmAction from "../../../../store/confirm/action";
import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Col, Modal } from "reactstrap";
import {
  GET_DT_ONSHORE,
  GET_DT_ONSHORE_COLUMN,
  GET_METER,
  GET_ONSHORE_REFRESH,
  GET_QTYPOINT,
  SAVE_DT_ONSHORE,
  SAVE_DT_ONSHORE_COLUMN,
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import SelectColor, { colorOption } from "components/Custom/SelectColor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { getPermission } from "../../../../helpers/auth_helper";
import moment from "moment";
import { post } from "helpers/api_helper";
import { set } from "lodash";
import { useDispatch } from "react-redux";

function numberFormat(number, digit = 2) {
  if (number === null || number === "null" || number === "") return "";
  function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
  return parseFloat(number).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
}

function Onshore(props) {
  const dispatch = useDispatch();
  const permission = getPermission();
  const [AVGObject, setAVGObject] =useState({mode:"AVG",show_name:""});
  //   const [dateSelected, setDateSelected] = useState(props.dateSelected);
  const [dateNow, setDateNow] = useState(moment(new Date()).format("YYYY-MM"));
  const [showManageColumn, setShowManageColumn] = useState(false);
  const [customerOption, setCustomerOption] = useState([]);
  const [columnDataList, setColumnDataList] = useState([]);
  const [columnManageList, setColumnManageList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [columnRenderList, setColumnRenderList] = useState([
    {
      dataField: "Dummy",
      text: "Date",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
        width: "2%",
      },
      formatter: CountIndexRow,
    },
  ]);

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (
      rowIndex == modelDeviceList.length - 1 &&
      dateNow == moment(props.dateSelected).format("YYYY-MM")
    ) {
      style.fontWeight = "bold";
      style.color = "#FFFFFF";
      style.border = "2px solid #FFFFFF";
      // style.opacity = "0.6";
    } else {
      style.color = "white";
    }

    return style;
  };

  const calculateAVG = () => {
    let planAvg =
      modelDeviceList.reduce(
        (a, b) => a + parseFloat(b.ONSHORE_DATA),
        0
      ) / modelDeviceList.length;
    let avgObj = { mode:"AVG",date: "AVG", ONSHORE_DATA: planAvg };
    columnDataList.map(collumn => {
      let sum = 0;
      modelDeviceList.map(object => {
        sum += object[collumn.ONSHORECOLUMN_NAME];
      });
      avgObj[collumn.ONSHORECOLUMN_NAME] = sum / modelDeviceList.length;
    });
    setAVGObject(avgObj);
  };

  useEffect(() => {
    calculateAVG();
  }, [modelDeviceList]);

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };

  const addHeaderTable = () => {
    let prevHeader = document.getElementById("onshore-gas-volume-table-header");
    prevHeader && prevHeader.remove();
    let thead = document
      .getElementById("onshore-tab-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '<th id="onshore-gas-volume-table-header" colspan="' +
      (columnDataList.length + 2) +
      '" style="text-align:center;background-color:#556ee6;color:#FFFFFF">Onshore Gas Volume</th>';
    thead.prepend(tr);
  };
  const getColumn = () => post(GET_DT_ONSHORE_COLUMN, {});
  const handleAddColumn = () => {
    setColumnManageList(prevent => [
      ...prevent,
      {
        ROW: columnManageList.length + 1,
        PID: "",
        ONSHORECOLUMN_ORDER: columnManageList.length + 1,
        ONSHORECOLUMN_NAME: "",
        SCADATAG_NAME: "",
        QTYPOINT_NAME: "",
        ONSHORECOLUMN_DESC: "",
        ONSHORECOLUMN_TYPE: "",
        ONSHORECOLUMN_SHOW: true,
        PRIORITY_FLAG: 0,
        STATUS_FLAG: 0,
        customer: [],
        color: colorOption[0],
        show: { label: "Show", value: 1 },
        source: { label: "Manual", value: 0 },
      },
    ]);
  };
  const handleSaveColumn = async () => {
    function validateDuplicate() {
      let valueArr = columnManageList.map(function (item) {
        return item.ONSHORECOLUMN_NAME;
      });
      let isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      return isDuplicate;
    }
    if (validateDuplicate()) {
      dispatch(messageAction.showMessage("Column name is duplicate."));
      throw "exit";
    }
    dispatch(loadingAction.showLoading());
    try {
      if (
        !columnManageList.some(
          row => row.ONSHORECOLUMN_NAME == "" || row.ONSHORECOLUMN_ORDER == ""
        )
      ) {
        let data = [...columnManageList];
        data = data.map(row => ({
          ...row,
          ONSHORECOLUMN_DESC: row.customer.map(qty => qty.label).toString(),
        }));
        let res = await post(SAVE_DT_ONSHORE_COLUMN, data);
        if (res.resultCode == 200) {
          fetchData();
          setShowManageColumn(false);
          dispatch(messageAction.showMessage("Save success."));
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const generateRow = () => {
    function addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }
    function getDaysInMonth(month, year) {
      var date = new Date(year, month, 1);
      var days = [];
      while (date.getMonth() === month) {
        days.push({
          date: new Date(date),
          ONSHORE_DATE: moment(new Date(date)).format("YYYY-MM-DD"),
          ONSHORE_DAY: new Date(date).getDate(),
        });
        date.setDate(date.getDate() + 1);
      }
      return days;
    }
    let currentDate = addDays(new Date(), -1);
    let startDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    let dayList;
    let dateDiff = currentDate.getDate() - startDate.getDate() + 1;

    if (
      props.dateSelected &&
      (props.dateSelected.getFullYear() < currentDate.getFullYear() ||
        (props.dateSelected.getMonth() < currentDate.getMonth() &&
          props.dateSelected.getFullYear() == currentDate.getFullYear()))
    ) {
      dayList = getDaysInMonth(
        props.dateSelected.getMonth(),
        props.dateSelected.getFullYear()
      );
    } else {
      dayList = getDaysInMonth(
        currentDate.getMonth(),
        currentDate.getFullYear()
      );
      dayList = dayList.slice(0, dateDiff);
    }
    dayList = addFieldToModelDeviceList(dayList);
    setModelDeviceList(dayList);
  };
  const ButtonAction = (cellContent, row) => {
    return (
      <div>
        {permission.eGLP && (
          <>
            <button
              type="button"
              className="btn btn-sm btn-secondary  me-2"
              // onClick={() => { refreshData(row) }}
              onClick={() => {
                dispatch(
                  confirmAction.showConfirm(
                    "ต้องการ Refresh หรือไม่ ? หากต้องการ Refresh ระบบจะทำการล้างค่าปัจจุบัน",
                    () => {
                      refreshData(row)
                    }
                  )
                );
              }}
            >
              Refresh
            </button>
            <button
              type="button"
              className="btn btn-sm btn-success me-2"
              onClick={() => {
                handleSaveDataByRow(row);
              }}
            >
              Save
            </button>
          </>
        )}
      </div>
    );
  };

  const formatNumber = (cellContent, row) => {
    return <div>{numberFormat(cellContent, 2)}</div>;
  };


  const renderColumn = () => {
    // console.log(columnDataList)
    setColumnRenderList([
      {
        dataField: "Dummy",
        text: "Date",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: "#556ee6",
          width: "50px",
          fontSize: "12px",
        },
        style: { width: "50px" },
        formatter: CountIndexRow,
      },
      ...columnDataList
        .sort((a, b) =>
          a.ONSHORECOLUMN_ORDER > b.ONSHORECOLUMN_ORDER
            ? 1
            : b.ONSHORECOLUMN_ORDER > a.ONSHORECOLUMN_ORDER
              ? -1
              : 0
        )
        .filter(
          obj =>
            obj.ONSHORECOLUMN_SHOW == true || obj.ONSHORECOLUMN_SHOW == "true"
        )
        .map(obj => ({
          dataField: obj.ONSHORECOLUMN_NAME.replaceAll(".", "_"),
          text: obj.ONSHORECOLUMN_NAME,
          headerAlign: "center",
          editable: true,
          align: "center",
          editorStyle: () => {
            return { height: "25px" }
          },
          headerStyle: {
            backgroundColor: colorOption[obj.ONSHORECOLUMN_TYPE].label,
            width: "90px",
            fontSize: "12px",
          },
          formatter: formatNumber,
          style: { width: "90px", cursor: "pointer" },
          // formatter: formatNumber,
          classes: (cell, row, rowIndex, colIndex) => {
            let className = "";
            if (obj.STATUS_FLAG != 0) className += "from-source";
            if (obj.STATUS_FLAG == 1 || obj.STATUS_FLAG == 3)
              className += " pmis";
            return className;
          },
          validator: (newValue, row, column, done) => {
            setTimeout(() => {
              if (isNaN(newValue)) {
                return done({
                  valid: false,
                  message: "Should be numeric",
                });
              }
              return done();
            }, 0);
            return {
              async: true,
            };
          },
        })),
      {
        dataField: "Action",
        text: "Action",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: "#556ee6",
          width: "150px",
          fontSize: "12px",
        },
        style: { width: "150px", },
        formatter: ButtonAction,
      },
    ]);
  };
  const handleShowManageColumn = async () => {
    setColumnManageList([]);
    dispatch(loadingAction.showLoading());
    try {
      setShowManageColumn(true);
      let column = await getColumn();
      // console.log(column);
      setColumnManageList(
        column.data.dtOnshoreColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          customer: obj.ONSHORECOLUMN_DESC
            ? customerOption.filter(
              opt => obj.ONSHORECOLUMN_DESC.split(",").indexOf(opt.label) >= 0
            )
            : [],
          color: colorOption[obj.ONSHORECOLUMN_TYPE],
          show:
            obj.ONSHORECOLUMN_SHOW == 1
              ? { label: "Show", value: 1 }
              : { label: "Hide", value: 0 },
          source:
            obj.STATUS_FLAG == 0
              ? { label: "Manual", value: 0 }
              : obj.STATUS_FLAG == 1
                ? { label: "Scada", value: 1 }
                : { label: "Flow Selection", value: 2 },
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }

    dispatch(loadingAction.hideLoading());
  };
  const handleSaveData = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];
      // console.log(modelDeviceList);
      modelDeviceList.map(obj => {
        columnDataList.map(objColumn => {
          data.push({
            ...obj[
            `${objColumn.ONSHORECOLUMN_NAME.replaceAll(".", "_")}__data`
            ],
            ONSHORE_DATA:
              obj[objColumn.ONSHORECOLUMN_NAME.replaceAll(".", "_")],
          });
        });
      });
      let res = await post(SAVE_DT_ONSHORE, data);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Save success."));
        fetchData();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const handleSaveDataByRow = async row => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];
      columnDataList.map(objColumn => {
        data.push({
          ...row[`${objColumn.ONSHORECOLUMN_NAME.replaceAll(".", "_")}__data`],
          ONSHORE_DATA: row[objColumn.ONSHORECOLUMN_NAME.replaceAll(".", "_")],
        });
      });

      let res = await post(SAVE_DT_ONSHORE, data);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Save success."));
        // fetchData()
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const refreshData = async (row) => {
    // console.log(row)
    dispatch(loadingAction.showLoading());
    try {
      let refresh = await post(GET_ONSHORE_REFRESH, { SEARCH_DATE: row.ONSHORE_DATE })
      if (refresh.resultCode == 200) {
        dispatch(messageAction.showMessage("Refresh success."));
        fetchData();
      } else {
        dispatch(messageAction.showMessage(refresh.resultDescription));

      }
      // let data = await post(GET_DT_ONSHORE, {
      //   ONSHORE_DATE: row.ONSHORE_DATE,
      // });
      // console.log(data,dataList)

      // setDataList(data.data.dtOnshoreList);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  }
  const fetchData = async () => {
    dispatch(loadingAction.showLoading());

    try {
      // generateRow();
      let column = await getColumn();
      setColumnDataList(
        column.data.dtOnshoreColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
        }))
      );
      let data = await post(GET_DT_ONSHORE, {
        ONSHORE_MONTHYEAR: moment(props.dateSelected).format("YYYY-MM-01"),
      });
      setDataList(data.data.dtOnshoreList);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const getOption = async () => {

    try {
      let res = await post(GET_METER, {});
      setCustomerOption(
        res.data.MeterList.map(obj => ({
          label: obj.ALIAS_NAME,
          value: obj.PID,
        })).sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));

    }
  };
  useEffect(() => {
    //fixed header table
    let tableId = "onshore-tab-table";
    let scrollY = 195;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        for (var i = 0; i < tr?.childNodes.length; i++) {
          th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
    //fixed header table
  }, []);
  useEffect(() => {
    let data = [];
    modelDeviceList.map(obj => {
      columnDataList.map(objColumn => {
        if (
          obj[`${objColumn.ONSHORECOLUMN_NAME.replaceAll(".", "_")}__data`]
            .PID == ""
        ) {
          data.push({
            ...obj[
            `${objColumn.ONSHORECOLUMN_NAME.replaceAll(".", "_")}__data`
            ],
            ONSHORE_DATA:
              obj[objColumn.ONSHORECOLUMN_NAME.replaceAll(".", "_")],
          });
        }
      });
    });

    if (data.length > 0) {
      // console.log('onshore')
      intialSave(data);
    }
  }, [modelDeviceList]);
  const intialSave = async data => {
    if(permission.eGLP ){
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(SAVE_DT_ONSHORE, data);
      if (res.resultCode == 200) {
        // dispatch(messageAction.showMessage("Save success."));
        fetchData();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  }
  };
  useEffect(() => {
    generateRow();
  }, [dataList]);
  useEffect(() => {
    getOption();
    fetchData();
  }, [props.dateSelected]);
  useEffect(() => {
    renderColumn();
    addHeaderTable();
    // if (columnDataList.length > 1) {
    //   generateRow();
    // }
  }, [columnDataList]);
  // useEffect(()=>{
  //   if(modelDeviceList.length){
  //     saveNewData()
  //   }
  // },[modelDeviceList])
  // const saveNewData = async () => {
  //   dispatch(loadingAction.showLoading());
  //   try {
  //     let data = [];
  //     modelDeviceList.map(obj => {
  //       columnDataList.map(objColumn => {
  //         data.push({
  //           ...obj[
  //           `${objColumn.ONSHORECOLUMN_NAME.replaceAll(".", "_")}__data`
  //           ],
  //           ONSHORE_DATA:
  //             obj[objColumn.ONSHORECOLUMN_NAME.replaceAll(".", "_")],
  //         });
  //       });
  //     });
  //     data = data.filter(row=>row.PID=="")

  //     if(data.length>0){
  //       let res = await post(SAVE_DT_ONSHORE, data);
  //       if (res.resultCode == 200) {
  //         fetchData();
  //       } else {
  //         dispatch(messageAction.showMessage(res.resultDescription));
  //       }
  //     }

  //   } catch (error) {
  //     dispatch(messageAction.showMessage(error.message));
  //   }
  //   dispatch(loadingAction.hideLoading());
  // };
  const addFieldToModelDeviceList = rowList => {
    let dataModel = {
      PID: "",
      ONSHORE_DATE: "",
      ONSHORECOLUMN_PID: "",
      ONSHORECOLUMN_ORDER: 0,
      ONSHORECOLUMN_NAME: "",
      ONSHORE_DAY: 0,
      ONSHORE_DATA: 0,
      SOURCE_PID: null,
      SOURCE_NAME: null,
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
    };
    if (rowList.length > 0) {
      let data = dataList;
      let modelList = [];
      columnDataList.map(objColumn => {
        // console.log(objColumn)
        modelList = rowList.map(obj => {
          let value = data.find(
            value =>
              value.ONSHORECOLUMN_PID == objColumn.PID &&
              value.ONSHORE_DAY == obj.ONSHORE_DAY
          );
          obj[objColumn.ONSHORECOLUMN_NAME.replaceAll(".", "_")] = value
            ? value.ONSHORE_DATA
            : 0;
          obj[`${objColumn.ONSHORECOLUMN_NAME.replaceAll(".", "_")}__data`] = {
            ...dataModel,
            ...value,
            ONSHORE_DATE: obj.ONSHORE_DATE,
            ONSHORE_DAY: obj.ONSHORE_DAY,
            ONSHORECOLUMN_PID: objColumn.PID,
            ONSHORECOLUMN_ORDER: objColumn.ONSHORECOLUMN_ORDER,
            ONSHORECOLUMN_NAME: objColumn.ONSHORECOLUMN_NAME,
          };
          return { ...obj };
        });
      });
      return modelList;
    }
  };
  const columnOption = {
    menu: (provided, state) => ({
      ...provided,
      width: 270,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#2E3446" : undefined,
      };
    },
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: "#2A3042",
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "#FFFFFF",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#BFC8E2",
      ":hover": {
        backgroundColor: "#2A3042",
        color: "white",
      },
    }),
  };
  const SelectCustomer = (cellContent, row) => {
    return (
      <div>
        {row.STATUS_FLAG == 2 && (
          <Select
            value={cellContent}
            isClearable={false}
            isMulti
            onChange={selected => {
              setColumnManageList(prev => {
                return prev.map(obj => {
                  if (row.ROW == obj.ROW) {
                    return {
                      ...obj,
                      customer: selected,
                    };
                  }
                  return { ...obj };
                });
              });
            }}
            options={customerOption}
            classNamePrefix="select2-selection"
            styles={columnOption}
          />
        )}
      </div>
    );
  };
  const PickColor = (cellContent, row) => {
    return (
      <SelectColor
        value={cellContent}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  color: selected,
                  ONSHORECOLUMN_TYPE: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };

  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }

  const SelectShow = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Show", value: 1 },
          { label: "Hide", value: 0 },
        ]}
        classNamePrefix="select2-selection"
        styles={SelectStyle}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  show: selected,
                  ONSHORECOLUMN_SHOW: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const SelectSource = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Manual", value: 0 },
          { label: "Scada", value: 1 },
          { label: "Flow Selection", value: 2 },
        ]}
        classNamePrefix="select2-selection"
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  source: selected,
                  STATUS_FLAG: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const columnManage = [
    {
      dataField: "ONSHORECOLUMN_ORDER",
      text: "Order",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "30px",
        cursor:"pointer",
      },
      type: "number",
    },

    {
      dataField: "ONSHORECOLUMN_NAME",
      text: "Column Name",
      headerAlign: "center",
      sort: true,
      editable: (content, row, rowIndex, columnIndex) => row.PID == "",
      align: "center",
      style: {
        width: "70px",
      },
    },
    ,
    {
      dataField: "source",
      text: "Source",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "125px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectSource,
    },
    {
      dataField: "SCADATAG_NAME",
      text: "SCADA Tag",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "170px",
        cursor:"pointer",
      },
    },
    {
      dataField: "customer",
      text: "Customer",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      style: {
        width: "160px",
      },
      formatter: SelectCustomer,
    },
    // {
    //   dataField: "QTYPOINT_NAME",
    //   text: "Quality Point",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",  style: {
    //       width: "100px",
    //     },
    // },
    // {
    //   dataField: "GMDRTAG_NAME",
    //   text: "GMDR Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //       width: "100px",
    //     },
    // },

    {
      dataField: "color",
      text: "Color",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "70px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: PickColor,
    },
    {
      dataField: "show",
      text: "Status",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "100px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectShow,
    },
    // {
    //   dataField: "ACTION",
    //   isDummyField: true,
    //   text: "Action",
    //   headerAlign: "center",
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   formatter: deleteColumnButton,
    // },
  ];
  return (
    <div>
      <Col sm="12">
        <div className="d-flex justify-content-end">
          {permission.mMIM && (
            <button
              type="button"
              className="btn btn-primary me-2"
              onClick={() => handleShowManageColumn()}
            >
              <i className="bx bx-columns"></i>&nbsp; Manage Column Onshore Gas
              Volume
            </button>
          )}
          {/* <button
                        type="button"
                        className="btn btn-success me-2"
                        onClick={handleSaveData}
                    >
                        <i className="bx bx-save"></i>&nbsp;
                        Save
                    </button> */}
        </div>
        <div className="mt-2">
          <BootstrapTable
            id="onshore-tab-table"
            keyField="date"
            data={modelDeviceList}
            columns={columnRenderList}
            rowStyle={rowStyle}
            headerClasses="header-style"
            cellEdit={cellEditFactory({
              onStartEdit: (oldValue, newValue, row, column) => {
                $("#onshore-tab-table .form-control.editor.edit-text").bind(
                  "enterKey",
                  function (e) {
                    let cell = $(this).parent().next();
                    setTimeout(() => {
                      cell.click();
                    }, 50);
                  }
                );
                $("#onshore-tab-table .form-control.editor.edit-text").keypress(
                  function (e) {
                    if (e.keyCode == 13) {
                      $(this).trigger("enterKey");
                    }
                  }
                );
              },
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                calculateAVG();
                // console.log(column);
              },
            })}
          />
         <BootstrapTable
              id="onshore-tab-avg-table"
              keyField="mode"
              data={[AVGObject]}
              columns={[
                {
                  dataField: "mode",
                  text: "",
                  headerAlign: "center",
                  editable: false,
                  align: "center",
                  headerStyle: {
                    backgroundColor: "#7E8EDA",
                    width: "50px",
                  },
                  style: { width: "50px" },
                },
                ...columnRenderList.filter((row, index) => index != 0 && index != columnRenderList.length-1),
                {
                  dataField: "show_name",
                  text: "",
                  headerAlign: "center",
                  editable: false,
                  align: "center",
                  headerStyle: {
                    backgroundColor: "#7E8EDA",
                    width: "150px",
                  },
                  style: { width: "150px" },
                },
              ]}
              rowStyle={rowStyle}
              wrapperClasses={"hidden-column mt-4"}
              headerClasses="header-style hide"
            />
        </div>
      </Col>
      <Modal size="xl" isOpen={showManageColumn} backdrop={"static"} style={{ maxWidth: "90%" }}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Manage Onshore Gas Volume</h5>

          <button
            type="button"
            onClick={() => {
              setShowManageColumn(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <BootstrapTable
            id="collumn-onshore-table"
            keyField="ROW"
            wrapperClasses="table-on-scroll"
            data={columnManageList}
            columns={columnManage}
            rowStyle={rowStyleFontWhite}
            headerClasses="header-style"
            defaultSorted={defaultSortColumnManage}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              beforeSaveCell: (oldValue, newValue, row, column) => { },
            })}
          />
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleAddColumn()}
            >
              <i className="bx bx-plus"></i>&nbsp; Add
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleSaveColumn()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowManageColumn(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
const defaultSortColumnManage = [
  {
    dataField: "ONSHORECOLUMN_ORDER",
    order: "asc", // or desc
  },
];
export default Onshore;

const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

//headerColumn
const deleteColumnButton = (cell, row) => (
  <OverButton
    onClick={() => {
      // onDelete(row);
    }}
    color="danger"
    icon="fas fa-trash-alt"
    label="Delete"
  />
);

Onshore.propTypes = {
  dateSelected: PropTypes.any,
};
